module.exports = __webpack_public_path__ + "static/img/X2.48f9270a.jpg";